export const normalizeDeviceVersion = deviceVersion => {
  return deviceVersion ? deviceVersion.split('-')[0] : '1.0.0';
};
